exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".m-paymentMethod-payPalForm[data-v-5f2cc742]{padding:.475em}@media (min-width:1024px){.m-paymentMethod-payPalForm[data-v-5f2cc742]{padding:.675em 1.875em}}.m-paymentMethod-payPalForm .a-input-text__label[data-v-5f2cc742]{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f2cc742","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./vue/checkout/components/molecules/PayPal.vue
// module id = 488
// module chunks = 2